var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotuploader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Padding__x26__Artboard"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.74927,16.55811c0.19336,0,0.3501-0.15625,0.3501-0.34961v-1.63086h1.63037    c0.19336,0,0.3501-0.15625,0.3501-0.34961s-0.15674-0.34961-0.3501-0.34961h-1.63037v-1.63086    c0-0.19336-0.15674-0.34961-0.3501-0.34961s-0.3501,0.15625-0.3501,0.34961v1.63086H32.7688    c-0.19336,0-0.3501,0.15625-0.3501,0.34961s0.15674,0.34961,0.3501,0.34961h1.63037v1.63086    C34.39917,16.40186,34.55591,16.55811,34.74927,16.55811z",
    style: {
      fill: "#303030"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.84106,31.62842c2.15283,0,3.90381-1.75195,3.90381-3.9043s-1.75098-3.9043-3.90381-3.9043     s-3.9043,1.75195-3.9043,3.9043S20.68823,31.62842,22.84106,31.62842z M22.84106,24.56689     c1.74121,0,3.15771,1.41602,3.15771,3.15723s-1.4165,3.15723-3.15771,3.15723s-3.1582-1.41602-3.1582-3.15723     S21.09985,24.56689,22.84106,24.56689z",
    style: {
      fill: "#303030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.10712,26.01221c0.21362,0.53021,0.33795,1.10602,0.33795,1.71191     c0,2.53906-2.06543,4.60352-4.604,4.60352c-2.53906,0-4.60449-2.06445-4.60449-4.60352c0-0.6059,0.12439-1.1817,0.33801-1.71191     h-6.95422h-0.7002v9.07129c0,0.56152,0.45752,1.01855,1.02002,1.01855h21.79053c0.56836,0,1.03076-0.46191,1.03076-1.03027     v-9.05957h-0.7002H27.10712z",
    style: {
      fill: "#303030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.74146,19.33838h-5.86719l-1.24951-2.2168c-0.1748-0.3125-0.50586-0.50586-0.86328-0.50586     h-5.84131c-0.35742,0-0.68848,0.19336-0.86279,0.50488l-1.25049,2.21777h-5.87744c-0.55664,0-1.00928,0.45215-1.00928,1.00879     v4.96582h0.7002h7.31598c0.8125-1.31042,2.25238-2.19238,3.90472-2.19238c1.65204,0,3.0918,0.88196,3.90424,2.19238h7.31598     h0.7002v-4.95508C34.76147,19.79541,34.30396,19.33838,33.74146,19.33838z",
    style: {
      fill: "#303030"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotuploader);
export default __webpack_public_path__ + "static/media/photuploader.2b11151157578e1f607775e1c2c40126.svg";
export { ForwardRef as ReactComponent };